import React, { useEffect, useRef } from 'react'
import { TagAsSelect, ValidationMessage } from '../..'
import { getInputTagData } from './utils'
import { isEmpty } from 'lodash'
import { RuleModuleValueSelectProps } from './types'

const RuleModuleValueSelect: React.FC<RuleModuleValueSelectProps> = (props) => {
    const {
        index,
        vendor,
        uniqueKey,
        placeHolder = 'Select Items',
        setSelectedModuleValues,
        fetchModal,
        selectedValue,
        hasBranchFeature,
        errorMessage
    } = props

    const [showData, setShowData] = React.useState([])
    const [tagData, setTagData] = React.useState([])

    const selectedUids = selectedValue?.map((entry) => entry.uid)

    const updateTagData = (values: any) => {
        // Extract UIDs once instead of mapping multiple times
        const newValuesUids = values.map((el: any) => el.value)

        // Update the Parent State
        setSelectedModuleValues((prev) => {
            // Early return if no previous data for this index
            if (!prev[index]) {
                return { ...prev, [index]: { assets: newValuesUids } }
            }

            // Get the keys from current index to determine the module type
            const currentKeys = Object.keys(prev[index])

            // Create new values object with the same keys but updated values
            const newValuesObj = {
                [currentKeys[0]]: prev[index][currentKeys[0]].filter((el: any) => newValuesUids.includes(el.uid))
            }
            const updatedStateData = { ...prev, [index]: newValuesObj }

            // Return updated state without unnecessary cloning and deletion
            return updatedStateData
        })

        // Update local state
        setShowData(newValuesUids)
        setTagData(values)
    }

    useEffect(() => {
        setShowData(selectedUids)
        setTagData(getInputTagData(vendor, selectedValue, selectedUids, hasBranchFeature))
    }, [selectedValue])

    const baseTestId = `${uniqueKey}-${placeHolder.toLowerCase().split(' ').join('-')}`
    return (
        <div className="flex">
            <div className="select-items" data-test-id={`${baseTestId}-items-wrapper`}>
                {showData && showData.length > 0 ? (
                    <TagAsSelect
                        version="v2"
                        tags={tagData}
                        maxCount={23}
                        updateTag={updateTagData}
                        openModalCb={fetchModal}
                        showTooltip={hasBranchFeature ? false : true}
                        testId={`${baseTestId}-selected-tags`}
                        showCount={false}
                        showEmptyState={false}
                    />
                ) : (
                    <>
                        <TagAsSelect
                            version="v2"
                            tags={[]}
                            showEmptyState={true}
                            openModalCb={fetchModal}
                            placeholder={placeHolder}
                            testId={`${baseTestId}-empty-tags`}
                            showCount={false}
                            updateTag={() => { }}
                            error={true && !isEmpty(errorMessage)}
                        />
                        <ValidationMessage
                            style={{
                                maxWidth: '15rem'
                            }}
                            version="v2"
                            testId={`${baseTestId}-input-module-value-error`}>
                            {errorMessage}
                        </ValidationMessage>
                    </>
                )}
            </div>
        </div>
    )
}

export default RuleModuleValueSelect
